import React from 'react';
import { cn } from '../lib/utils';
import {
  fieldControlClassName,
  fieldDensityClassName,
  type FieldControlSize,
  type FieldDensity,
} from './input';

export interface TextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  error?: boolean;
  density?: FieldDensity;
  size?: FieldControlSize;
}

const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, error, density, size, ...props }, ref) => {
    return (
      <textarea
        className={cn(
          fieldControlClassName,
          fieldDensityClassName(density, size),
          density === 'comfort'
            ? 'min-h-12'
            : size === 'compact'
              ? 'min-h-8'
              : size === 'toolbar'
                ? 'min-h-9'
                : 'min-h-11',
          'h-auto resize-y',
          className,
          error && 'border-status-danger-fg focus:border-status-danger-fg focus:ring-focus',
        )}
        ref={ref}
        {...props}
        aria-invalid={error || props['aria-invalid']}
        aria-required={props.required || props['aria-required']}
      />
    );
  },
);
Textarea.displayName = 'Textarea';

export { Textarea };
